import { CookieDomain } from './types';

const LOCAL_HOST = 'localhost';
const LOCAL_ALIASES = [LOCAL_HOST, '127.0.0.1'];
const ROVER_LOCAL = 'rover.local';
const CIAF_LOCAL = 'ciaf.local';
const ROVER_CDN_STAGING = '.roverstaging.com';
const CIAF_STAGING = '.catinaflat.dev';
const ROVER_COM = '.rover.com';
const GITHUB_PREVIEW = '.app.github.dev';

// .co.uk must come before .com so it matches first
const CIAF_PRODUCTION_DOMAINS: CookieDomain[] = [
  '.catinaflat.co.uk',
  '.catinaflat.com',
  '.catinaflat.de',
  '.catinaflat.at',
  '.catinaflat.be',
  '.catinaflat.fr',
  '.catinaflat.ie',
  '.catinaflat.nl',
  '.catinaflat.ch',
  '.catinaflat.es',
  '.catinaflat.ca',
];

const getCookieDomain = (host: string): CookieDomain => {
  if (LOCAL_ALIASES.includes(host)) {
    return LOCAL_HOST;
  }

  if (host === ROVER_LOCAL) {
    return ROVER_LOCAL;
  }

  if (host === CIAF_LOCAL) {
    return CIAF_LOCAL;
  }

  if (host.endsWith(ROVER_CDN_STAGING)) {
    return ROVER_CDN_STAGING;
  }

  if (host.endsWith(CIAF_STAGING)) {
    return CIAF_STAGING;
  }

  if (host.includes(GITHUB_PREVIEW)) {
    return GITHUB_PREVIEW;
  }

  for (const domain of CIAF_PRODUCTION_DOMAINS) {
    if (host.endsWith(domain)) {
      return domain;
    }
  }

  return ROVER_COM;
};

export default getCookieDomain;
